import React, { memo, useState, useEffect, useMemo } from "react";
import { Stack } from "investira.react.components";
import { PageTemplate } from "../../components/templates";
import { useSelector } from "react-redux";
import { SearchIndicadoresAdd } from "../../components/organisms";
import BenchmarksSugestao from "./BenchmarksSugestao";
import BenchmarkList from "./BenchmarkList";
import services from "../../services";
import withResponseHandling from "../../hoc/withResponseHandling";

const Benchmarks = memo((props) => {
  const { default_entidade_id } = useSelector(
    (store) => store.entidade.current
  );

  const storedIndicadores = useSelector((store) => store.indicadores.data);

  const [benchmarks, setBenchmarks] = useState([]);
  const [isLoading, setIsLoading] = useState([]);

  const xIndicadores = useMemo(() => {
    const xIndicadoresFlatted = Object.values(storedIndicadores || {}).flatMap(
      (pLevel) => (Array.isArray(pLevel) ? pLevel : Object.values(pLevel))
    );

    const xIndicadoresFiltered = xIndicadoresFlatted
      .filter((xIndicador) => {
        return [
          "DI",
          "USD",
          "IPCA",
          "IGPM",
          "INPC",
          "IBOV",
          "IMAB",
          "IFIX",
        ].includes(xIndicador.indicador_id);
      })
      .map((xIndicador) => {
        const { indicador, indicador_id } = xIndicador;
        return { indicador, indicador_id };
      });

    return xIndicadoresFiltered;
  }, [storedIndicadores]);

  function handleClick(pIndicador) {
    const { indicador_id, indicador } = pIndicador;
    services.benchmarks.add(
      {
        entidade_id: default_entidade_id,
        indicador_id: indicador_id,
        benchmark: indicador,
      },
      () => {
        services.benchmarks.list({ sort: "benchmark" }, (rRes) => {
          setBenchmarks(rRes.data);
        });
      },
      (rErr) => {
        props.responseErrorHandling(rErr);
      }
    );
  }

  function handleDelete(pBenchmarkId) {
    services.benchmarks.remove(
      {
        benchmark_id: pBenchmarkId,
      },
      () => {
        services.benchmarks.list({ sort: "benchmark" }, (rRes) => {
          setBenchmarks(rRes.data);
        });
      },
      (rErr) => {}
    );
  }

  useEffect(() => {
    setIsLoading(true);
    services.benchmarks.list(
      {},
      (rRes) => {
        setBenchmarks(rRes.data);
        // TODO: Se for vazio usar xIndicadores e preencher
        if (!rRes.data || Object.keys(rRes.data).length === 0) {
          // Se não houver benchmarks, adicionar todos os xIndicadores como benchmarks
          Promise.all(
            xIndicadores.map((xIndicador) =>
              services.benchmarks.add({
                indicador_id: xIndicador.indicador_id,
                benchmark: xIndicador.indicador,
              })
            )
          ).then(() => {
            // Após adicionar todos, buscar novamente a lista de benchmarks
            services.benchmarks.list({ sort: "benchmark" }, (rResList) => {
              setBenchmarks(rResList.data);
            });
          });
        }
      },
      (rErr) => {},
      () => {
        setIsLoading(false);
      }
    );
  }, [default_entidade_id]);

  return (
    <PageTemplate
      title="Benchmarks"
      maxWidth="lg"
      headerRenderActions={
        <BenchmarksSugestao
          benchmarks={benchmarks}
          setBenchmarks={setBenchmarks}
        />
      }
    >
      <Stack spacing={4}>
        <SearchIndicadoresAdd onClick={handleClick} pageIsLoading={isLoading} />
        <BenchmarkList
          benchmarks={benchmarks}
          onDelete={handleDelete}
          isLoading={isLoading}
        />
      </Stack>
    </PageTemplate>
  );
});

export default withResponseHandling(Benchmarks);
